function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P6Main = function P6Main(_ref) {
  var page = _ref.page;
  var thisPage = 8;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $('.p6-header').addClass('p6-header__active');
      }, 2500), setTimeout(function () {
        $('.p6-header-m').addClass('p6-header-m__active');
      }, 2500), setTimeout(function () {
        $('.p6-arrow').addClass('p6-arrow__active');
      }, 500), setTimeout(function () {
        $('.p6-house').addClass('p6-house__active');
      }, 500), setTimeout(function () {
        $('.p6-truck').addClass('p6-truck__active');
      }, 500), setTimeout(function () {
        $('.p6-clean').addClass('p6-clean__active');
      }, 500), setTimeout(function () {
        $('.p6-reuse').addClass('p6-reuse__active');
      }, 500), setTimeout(function () {
        $('.p6-recover').addClass('p6-recover__active');
      }, 500)]);
    } else {
      $('.p6-arrow').removeClass('p6-arrow__active');
      $('.p6-header').removeClass('p6-header__active');
      $('.p6-header-m').removeClass('p6-header-m__active');
      $('.p6-clean').removeClass('p6-clean__active');
      $('.p6-reuse').removeClass('p6-reuse__active');
      $('.p6-house').removeClass('p6-house__active');
      $('.p6-recover').removeClass('p6-recover__active');
      $('.p6-truck').removeClass('p6-truck__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p6/extract-use-dispose-2-copy@3x.png",
    className: "p6-header"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p6/posillico-s-wash-plant-is-at-the-forefront-of-sustainable-soil-copy@2x.png",
    className: "p6-header-m"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p6/use-graphic-lg.png",
    className: "p6-house"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p6/re-use@3x.png",
    className: "p6-reuse"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p6/clean-header@3x.png",
    className: "p6-clean"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p6/recover-header@3x.png",
    className: "p6-recover"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p6/recover-truck.png",
    className: "p6-truck"
  }), /*#__PURE__*/React.createElement("div", {
    className: "p6-arrow"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p6/recycling-circle-bg-wglare-2.png",
    className: "p6-arrow__spin"
  })));
};
export default P6Main;